import { Box } from "@chakra-ui/react";
import { useContext, useMemo } from "react";
import CustomTable from "../../../components/table/CustomTableV2";
import { AccountContext } from "../../../context/AccountContextComponent";

export const TenureFullDataTable = ({ profileMetrics }) => {
  const { aRankLabel, bRankLabel, cRankLabel } = useContext(AccountContext);
  const dataColumns = useMemo(() => {
    return [
      {
        Header: "Name",
        accessor: "name",
      },
      {
        Header: "Group",
        accessor: "tenureBucket",
      },
      {
        Header: "Tenure",
        accessor: (row) => {
          const currentDate = new Date();
          const startDate = new Date(row.startDate);
          const years = currentDate.getFullYear() - startDate.getFullYear();
          const months = currentDate.getMonth() - startDate.getMonth();
          const adjustedYears = months < 0 ? years - 1 : years;
          const adjustedMonths = months < 0 ? months + 12 : months;
          return adjustedYears * 12 + adjustedMonths; // returns total months for sorting
        },
        Cell: ({ value }) => {
          const years = Math.floor(value / 12);
          const months = value % 12;
          return `${years} years, ${months} months`;
        },
      },
      {
        Header: "Department",
        accessor: "department.name",
      },
      {
        Header: "Ranking",
        accessor: "ranking",
      },
    ];
  }, [profileMetrics]);

  const formattedData = useMemo(() => {
    if (!profileMetrics) return [];
    const rankingLabels = {
      A: aRankLabel,
      B: bRankLabel,
      C: cRankLabel,
      Unranked: "Unranked",
    };
    return profileMetrics?.map((profile) => {
      return {
        ...profile,
        ranking: rankingLabels[profile.ranking] || "Unranked",
      };
    });
  }, [profileMetrics]);

  return (
    <>
      <Box w={"100%"}>
        <CustomTable
          columns={dataColumns}
          data={formattedData || []}
          initialState={{
            sortBy: [
              { id: "tenureBucket", desc: false },
              { id: "name", desc: false },
            ],
          }}
          doUsePagination={true}
          showSearchBar={true}
          showDownloadLink={true}
          csvFileName={`employee_tenure`.replaceAll(" ", "_").toLowerCase()}
          csvMapping={{
            Name: "name",
            Email: "email",
            Tenure: "tenureBucket",
            Department: "department.name",
            Manager: "manager",
            "Start Date": "startDate",
            Ranking: "ranking",
          }}
          selectionType={"none"}
          boxStyle={{
            bg: "white",
            borderRadius: "10px",
            border: "1px",
            borderColor: "gray.200",
            p: 4,
            overflow: "auto",
          }}
          tableStyle={{
            size: "md",
          }}
          tableId={"tenureFullDataTable"}
        />
      </Box>
    </>
  );
};
